/**
 * Transition Rules: EnergyPlus 22.2 to 23.1
 *
 * This transition has no object schema changes - only version update
 * and potential report variable name mappings.
 */

import type { VersionTransition, ObjectTransitionRule } from '../types';

export function createTransition_22_2_to_23_1(): VersionTransition {
  const objectRules = new Map<string, ObjectTransitionRule>();
  const variableMappings = new Map<string, string>();
  const deletedObjects = new Set<string>();
  const renamedObjects = new Map<string, string>();

  // No object schema changes in this transition
  // Only version number update and potential report variable renames

  return {
    fromVersion: { major: 22, minor: 2 },
    toVersion: { major: 23, minor: 1 },
    objectRules,
    variableMappings,
    deletedObjects,
    renamedObjects,
  };
}
